<template lang="pug">
  q-select(v-bind="$attrs" v-model="model" :options="optionsCopy" @filter="filterFn")
</template>

<script>
export default {
  props: ['options', 'value'],
  data() {
    return {
      optionsCopy: this.options
    }
  },
  computed: {
    model: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  methods: {
    filterFn(val, update, abort) {
      update(() => {
        const needle = val.toLowerCase()
        this.optionsCopy = this.options.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
      })
    },
  }
}
</script>
